import videojs from 'video.js';

export class Languages {
  languages = {
    en: {
      'Audio Player': 'Audio Player',
      'Video Player': 'Video Player',
      'Play': 'Play',
      'Pause': 'Pause',
      'Replay': 'Replay',
      'Current Time': 'Current Time',
      'Duration Time': 'Duration Time',
      'Remaining Time': 'Remaining Time',
      'Stream Type': 'Stream Type',
      'LIVE': 'LIVE',
      'Loaded': 'Loaded',
      'Progress': 'Progress',
      'Progress Bar': 'Progress Bar',
      'progress bar timing: currentTime={1} duration={2}': '{1} of {2}',
      'Fullscreen': 'Fullscreen',
      'Non-Fullscreen': 'Non-Fullscreen',
      'Mute': 'Mute',
      'Unmute': 'Unmute',
      'Playback Rate': 'Playback Rate',
      'Subtitles': 'Subtitles',
      'subtitles off': 'subtitles off',
      'Captions': 'Captions',
      'captions off': 'captions off',
      'Chapters': 'Chapters',
      'Descriptions': 'Descriptions',
      'descriptions off': 'descriptions off',
      'Audio Track': 'Audio Track',
      'Volume Level': 'Volume Level',
      'You aborted the media playback': 'You aborted the media playback',
      'A network error caused the media download to fail part-way.': 'A network error caused the media download to fail part-way.',
      'The media could not be loaded, either because the server or network failed or because the format is not supported.': 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
      'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.': 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
      'No compatible source was found for this media.': 'No compatible source was found for this media.',
      'The media is encrypted and we do not have the keys to decrypt it.': 'The media is encrypted and we do not have the keys to decrypt it.',
      'Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled': 'Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled',
      'Something went wrong, the player cannot continue playback!': 'Something went wrong, the player cannot continue playback!',
      'The Browser doesn\'t support the DRM types that the content supports!': 'The web browser does not support DRM, please use other web browsers to play the content.',
      'Play Video': 'Play Video',
      'Close': 'Close',
      'Close Modal Dialog': 'Close Modal Dialog',
      'Modal Window': 'Modal Window',
      'This is a modal window': 'This is a modal window',
      'This modal can be closed by pressing the Escape key or activating the close button.': 'This modal can be closed by pressing the Escape key or activating the close button.',
      ', opens captions settings dialog': ', opens captions settings dialog',
      ', opens subtitles settings dialog': ', opens subtitles settings dialog',
      ', opens descriptions settings dialog': ', opens descriptions settings dialog',
      ', selected': ', selected',
      'captions settings': 'captions settings',
      'subtitles settings': 'subititles settings',
      'descriptions settings': 'descriptions settings',
      'Text': 'Text',
      'White': 'White',
      'Black': 'Black',
      'Red': 'Red',
      'Green': 'Green',
      'Blue': 'Blue',
      'Yellow': 'Yellow',
      'Magenta': 'Magenta',
      'Cyan': 'Cyan',
      'Background': 'Background',
      'Window': 'Window',
      'Transparent': 'Transparent',
      'Semi-Transparent': 'Semi-Transparent',
      'Opaque': 'Opaque',
      'Font Size': 'Font Size',
      'Text Edge Style': 'Text Edge Style',
      'None': 'None',
      'Raised': 'Raised',
      'Depressed': 'Depressed',
      'Uniform': 'Uniform',
      'Dropshadow': 'Dropshadow',
      'Font Family': 'Font Family',
      'Proportional Sans-Serif': 'Proportional Sans-Serif',
      'Monospace Sans-Serif': 'Monospace Sans-Serif',
      'Proportional Serif': 'Proportional Serif',
      'Monospace Serif': 'Monospace Serif',
      'Casual': 'Casual',
      'Script': 'Script',
      'Small Caps': 'Small Caps',
      'Reset': 'Reset',
      'restore all settings to the default values': 'restore all settings to the default values',
      'Done': 'Done',
      'Caption Settings Dialog': 'Caption Settings Dialog',
      'Beginning of dialog window. Escape will cancel and close the window.': 'Beginning of dialog window. Escape will cancel and close the window.',
      'End of dialog window.': 'End of dialog window.',
      '{1} is loading.': '{1} is loading.',
      'The application is updating information. You can watch premium content when the update has been completed.': 'The application is updating information. You can watch premium content when the update has been completed.',
      'This channel is not available in your package. You can subscribe the packages at ais.co.th or my AIS.': 'This channel is not available in your package. You can subscribe the packages at <a target="_blank" href="http://www.ais.co.th/play/en/package.html" >ais.co.th</a> or my AIS.',
      'This video content is not available in your package. You can subscribe the packages at ais.co.th or my AIS.': 'This video content is not available in your package. You can subscribe the packages at <a target="_blank" href="http://www.ais.co.th/play/en/package.html" >ais.co.th</a> or my AIS.',
      'This channel is not available in your package.': 'This channel is not available in your package.',
      'This video content is not available in your package.': 'This video content is not available in your package.',
      'This content is restricted by age.': 'This content is restricted by age.',
      'This content is restricted for unauthorized users. Please Login or register.': 'This content is restricted for unauthorized users. Please Login or register.',
      'Please Login': 'Please Login',
      'This content is restricted for your device.': 'This content is restricted for your device.',
      'This content is restricted for your country.': 'This content is restricted for your country.',
      'Preview time remaining - ': 'Preview time remaining - ',
      'Preview time ended': 'Preview time ended',
      'Open website': 'Open website',
    },
    th: {
      'Audio Player': 'ปรับเสียง',
      'Video Player': 'เล่นวีดีโอ',
      'Play': 'เล่น',
      'Pause': 'หยุด',
      'Replay': 'เล่นใหม่',
      'Current Time': 'เวลาปัจจุบัน',
      'Duration Time': 'ระยะเวลา',
      'Remaining Time': 'เวลาที่เหลือ',
      'Stream Type': 'ประเภทการสตรีม',
      'LIVE': 'สด',
      'Loaded': 'Loaded',
      'Progress': 'Progress',
      'Progress Bar': 'แถบเวลา',
      'progress bar timing': 'progress bar timing',
      'Fullscreen': 'แสดงเต็มจอ',
      'Non-Fullscreen': 'แบบไม่เต็มหน้าจอ',
      'Mute': 'ปิดเสียง',
      'Unmute': 'เปิดเสียง',
      'Playback Rate': 'อัตราการเล่น',
      'Subtitles': 'คำบรรยาย',
      'subtitles off': 'ปิดคำบรรยาย',
      'Captions': 'คำบรรยายใต้ภาพ',
      'captions off': 'ปิดคำบรรยายใต้ภาพ',
      'Chapters': 'บท',
      'Descriptions': 'คำอธิบาย',
      'descriptions off': 'ปิดคำอธิบาย',
      'Audio Track': 'แทร็กเสียง',
      'Volume Level': 'ระดับเสียง',
      'You aborted the media playback': 'ยกเลิกการเล่น',
      'A network error caused the media download to fail part-way.': 'เกิดข้อผิดพลาดการเชื่อมต่ออินเทอร์เน็ต ทำให้การสตรีมล้มเหลว',
      'The media could not be loaded, either because the server or network failed or because the format is not supported.': 'เกิดข้อผิดพลาดการเชื่อมต่ออินเทอร์เน็ต หรือ เซิร์ฟเวอร์ ทำให้การสตรีมล้มเหลว',
      'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.': 'ไม่สามารถสตรีมคอนเทนต์ เนื่องจากคุณสมบัติเบราว์เซอร์ของคุณไม่รองรับ',
      'No compatible source was found for this media.': 'ไม่สามารถสตรีมคอนเทนต์ เนื่องจากคุณสมบัติเบราว์เซอร์ของคุณไม่รองรับ',
      'The media is encrypted and we do not have the keys to decrypt it.': 'คอนเท้นถูกเข้ารหัส',
      'Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled': 'ขณะนี้บัญชีผู้ใช้งานของคุณมีการรับชมพร้อมกันเกินจำนวนอุปกรณ์ที่กำหนด กรุณาหยุดเล่นเนื้อหาจากบางอุปกรณ์ เพื่อสามารถเริ่มรับชมผ่านอุปกรณ์นี้ได้',
      'Something went wrong, the player cannot continue playback!': 'มีบางอย่างผิดพลาด ผู้เล่นไม่สามารถเล่นต่อได้!',
      'The Browser doesn\'t support the DRM types that the content supports!': 'เว็บเบราว์เซอร์นี้ไม่รองรับ DRM กรุณาใช้เว็บเบราว์เซอร์อื่นเพื่อรับชมคอนเทนต์',
      'Play Video': 'เล่นวีดีโอ',
      'Close': 'ปิด',
      'Close Modal Dialog': 'Close Modal Dialog',
      'Modal Window': 'Modal Window',
      'This is a modal window': 'This is a modal window',
      'This modal can be closed by pressing the Escape key or activating the close button.': 'This modal can be closed by pressing the Escape key or activating the close button.',
      ', opens captions settings dialog': ', opens captions settings dialog',
      ', opens subtitles settings dialog': ', opens subtitles settings dialog',
      ', opens descriptions settings dialog': ', opens descriptions settings dialog',
      ', selected': 'เลือก',
      'captions settings': 'ตั้งค่าคำอธิบายใต้ภาพ',
      'subtitles settings': 'ตั้งค่าคำบรรยาย',
      'descriptions settings': 'ตั้งค่าคำอธิบาย',
      'Text': 'ข้อความ',
      'White': 'สีขาว',
      'Black': 'สีดำ',
      'Red': 'สีแดง',
      'Green': 'สีเขียว',
      'Blue': 'สีน้ำเงิน',
      'Yellow': 'สีเหลือง',
      'Magenta': 'สีม่วงแดงเข้ม',
      'Cyan': 'สีฟ้า',
      'Background': 'พื้นหลัง',
      'Window': 'หน้าต่าง',
      'Transparent': 'โปร่งใส',
      'Semi-Transparent': 'โปร่งแสง',
      'Opaque': 'ทึบแสง',
      'Font Size': 'ขนาดตัวอักษร',
      'Text Edge Style': 'Text Edge Style',
      'None': 'ไม่มี',
      'Raised': 'เพิ่ม',
      'Depressed': 'ลด',
      'Uniform': 'Uniform',
      'Dropshadow': 'Dropshadow',
      'Font Family': 'Font Family',
      'Proportional Sans-Serif': 'Proportional Sans-Serif',
      'Monospace Sans-Serif': ' Monospace Sans-Serif',
      'Proportional Serif': 'Proportional Serif',
      'Monospace Serif': 'Monospace Serif',
      'Casual': 'Casual',
      'Script': 'Script',
      'Small Caps': 'Small Caps',
      'Reset': 'รีเซ็ต',
      'restore all settings to the default values': 'คืนค่าการตั้งค่าทั้งหมดเป็นค่าเริ่มต้น',
      'Done': 'เสร็จสิ้น',
      'Caption Settings Dialog': 'กล่องโต้ตอบการตั้งค่าคำบรรยาย',
      'Beginning of dialog window. Escape will cancel and close the window.': 'จุดเริ่มต้นของหน้าต่างโต้ตอบ Escape จะยกเลิกและปิดหน้าต่าง',
      'End of dialog window.': 'สิ้นสุดหน้าต่างโต้ตอบ',
      '{1} is loading': 'กำลังโหลด',
      'The application is updating information. You can watch premium content when the update has been completed.': 'แอปพลิเคชันกำลังอัปเดทข้อมูล คุณสามารถรับชมคอนเทนต์พรีเมียมได้เมื่อการอัปเดทเสร็จสิ้น',
      'This channel is not available in your package. You can subscribe the packages at ais.co.th or my AIS.': 'ช่องนี้ไม่รวมอยู่ในแพ็คเกจของคุณ คุณสามารถสมัครแพ็คเกจได้ที่ <a target="_blank" href="http://www.ais.co.th/play/package.html">ais.co.th</a> หรือ my AIS',
      'This video content is not available in your package. You can subscribe the packages at ais.co.th or my AIS.': 'วีดีโอเรื่องนี้ไม่รวมอยู่ในแพ็คเกจของคุณ คุณสามารถสมัครแพ็คเกจได้ที่ <a target="_blank" href="http://www.ais.co.th/play/package.html">ais.co.th</a> หรือ my AIS',
      'This content is restricted by age.': 'คอนเทนต์นี้ถูก จำกัด อายุ',
      'This content is restricted for unauthorized users. Please Login or register.': 'คอนเทนต์นี้จำกัดการใช้งาน กรุณาเข้าสู่ระบบหรือลงทะเบียนเพื่อใช้งาน',
      'Please Login': 'กรุณาเข้าสู่ระบบ',
      'This content is restricted for your device.': 'คอนเทนต์นี้ถูก จำกัด สำหรับอุปกรณ์ของคุณ',
      'This content is restricted for your country.': 'คอนเทนต์นี้ถูก จำกัด สำหรับประเทศของคุณ',
      'Preview time remaining - ': 'เวลาที่เหลือ สำหรับการรับชมตัวอย่าง - ',
      'Preview time ended': 'หมดเวลาแสดงตัวอย่างแล้ว',
      'Advertisement': 'โฆษณา',
      'Skip Ad': 'ข้ามโฆษณา',
      'Skip': 'ข้าม',
      'Skip in {1} sec': 'ข้ามใน {1} วินาที',
      'Learn More': 'เรียนรู้เพิ่มเติม',
      'Open website': 'เปิดเว็บไซต์',
      'of': 'ของ',
      '{1} of {2}': '{1} ของ {2}',
    },
    he: {
      'Audio Player': 'נגן אודיו',
      'Video Player': 'נגן וידאו',
      'Play': 'נגן',
      'Pause': 'השאה',
      'Replay': 'השהיה',
      'Current Time': 'זמן כעת',
      'Duration Time': 'משך זמן',
      'Remaining Time': 'זמן נותר',
      'Stream Type': 'Stream Type',
      'LIVE': 'שידור חי',
      'Loaded': 'נטען',
      'Progress': 'התקדמות',
      'Progress Bar': 'סרגל התקדמות',
      'progress bar timing': 'תזמון סרגל התקדמות',
      'Fullscreen': 'מסך מלא',
      'Non-Fullscreen': 'לא מסך מלא',
      'Mute': 'השתק',
      'Unmute': 'בטל השתקה',
      'Playback Rate': 'קצב השמעה',
      'Subtitles': 'כתוביות',
      'subtitles off': 'כתוביות כבויות',
      'Captions': 'כיתובים',
      'captions off': 'כיתובים כבויים',
      'Chapters': 'פרקים',
      'Descriptions': 'תיאורים',
      'descriptions off': 'תיאורים כבויים',
      'Audio Track': 'רצועת שמע',
      'Volume Level': 'עוצמת קול',
      'You aborted the media playback': 'ביטלת את הפעלת המדיה',
      'A network error caused the media download to fail part-way.': 'שגיאת רשת גרמה לכישלון הורדת המדיה באופן חלקי',
      'The media could not be loaded, either because the server or network failed or because the format is not supported.': 'לא ניתן היה לטעון את המדיה, משום שהשרת או הרשת נכשלו או משום שהפורמט אינו נתמך',
      'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.': 'הפעלת המדיה הופסקה בגלל בעיה טכנית או מכיוון שהדפדפן שלך לא תומך בסוג מדיה זה',
      'No compatible source was found for this media.': 'לא נמצא מקור תואם למדיה זו',
      'The media is encrypted and we do not have the keys to decrypt it.': 'המדיה מוצפנת ואין לנו את המפתחות לפענח אותה',
      'Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled': 'מצטערים, חשבונך חורג ממגבלת ההפצה המקסימאלית במקביל. אנא הפסק את הפעלת התוכן במכשיר אחר כדי להפעיל את הוידאו במכשיר זה',
      'The Browser doesn\'t support the DRM types that the content supports!': 'דפדפן זה אינו תומך בסוגי ה- DRM בהם התוכן תומך',
      'Play Video': 'נגן',
      'Close': 'סגור',
      'Close Modal Dialog': 'סגור תיבת דו שיח של המודל',
      'Modal Window': 'חלון מודל',
      'This is a modal window': 'זה חלון מודל',
      'This modal can be closed by pressing the Escape key or activating the close button.': 'ניתן לסגור מודל זה על ידי לחיצה על מקש Escape או הפעלת לחצן הסגירה',
      ', opens captions settings dialog': ', פותח את תיבת הדו-שיח של הגדרות כיתוב',
      ', opens subtitles settings dialog': ', פותח את תיבת הדו-שיח של הגדרות כתוביות',
      ', opens descriptions settings dialog': ', פותח תיבת דו-שיח הגדרות תיאור',
      ', selected': 'נבחר',
      'captions settings': 'הגדרות כיתובים',
      'subtitles settings': 'הגדרות כתוביות',
      'descriptions settings': 'הגדרות תיאורים',
      'Text': 'טקסט',
      'White': 'לבן',
      'Black': 'שחור',
      'Red': 'אדום',
      'Green': 'ירוק',
      'Blue': 'כחול',
      'Yellow': 'צהוב',
      'Magenta': 'מגנטה',
      'Cyan': 'טורקיז',
      'Background': 'רקע',
      'Window': 'חלון',
      'Transparent': 'שקוף',
      'Semi-Transparent': 'שקוף למחצה',
      'Opaque': 'אטום',
      'Font Size': 'גודל פונט',
      'Text Edge Style': 'סגנון טקסט קצה ',
      'None': 'אף אחד',
      'Raised': 'מורם',
      'Depressed': 'מדוכא',
      'Uniform': 'מדים',
      'Dropshadow': 'טיפת צל',
      'Font Family': 'גופן משפחה',
      'Proportional Sans-Serif': 'Proportional Sans-Serif',
      'Monospace Sans-Serif': ' Monospace Sans-Serif',
      'Proportional Serif': 'Proportional Serif',
      'Monospace Serif': 'Monospace Serif',
      'Casual': 'אגבי',
      'Script': 'תסריט',
      'Small Caps': 'אותיות קטנות',
      'Reset': 'אתחול',
      'restore all settings to the default values': 'שחזר את כל ההגדרות לערכי ברירת המחדל',
      'Done': 'בוצע',
      'Caption Settings Dialog': 'תיבת דו-שיח של הגדרות כיתוב',
      'Beginning of dialog window. Escape will cancel and close the window.': 'תחילת חלון תיבת דו-שיח. כפתור Escape יבטל ויסגור את החלון',
      'End of dialog window.': 'סוף חלון תיבת הדו-שיח',
      '{1} is loading': 'טוען',
      'This channel is not available in your package.': 'ערוץ זה אינו זמין בחבילה שלך.',
      'This video content is not available in your package.': 'תוכן וידאו זה אינו זמין בחבילה שלך.',
      'This content is restricted by age.': 'תוכן זה מוגבל לפי גיל',
      'This content is restricted for unauthorized users. Please Login or register.': 'תוכן זה מוגבל למשתמשים לא מורשים. אנא התחבר או הירשם',
      'Please Login': 'אנא התחבר',
      'This content is restricted for your device.': 'תוכן זה מוגבל למכשיר שלך',
      'This content is restricted for your country.': 'תוכן זה מוגבל למדינתך',
      'Preview time remaining - ': 'Preview time remaining - ',
      'Advertisement': 'פרסומת',
      'Skip Ad': 'לדלג על מודעה',
      'Skip': 'לדלג',
      'Skip in {1} sec': 'דלג בעוד {1} שניות',
      'Learn More': 'למד עוד',
      'Open website': 'פתח אתר',
      'of': 'שֶׁל',
      '{1} of {2}': '{1} שֶׁל {2}'
    },
  };

  init() {
    for (const langKey in this.languages) {
      videojs.addLanguage(langKey, this.languages[langKey]);
    }
  }

  getLang(code) {
    if (this.languages[code]) {
      return this.languages[code];
    }
    return null;
  }
}

export default new Languages();
